import React from 'react';
import { Typography } from '@mui/material';
import { toSimpleLink } from '../../../lib/helpers';

export const getWebhookEndpointPausedForFailuresEventProps = <
	T extends {
		event: { id: string; message?: string | null };
	}
>(
		eventProps: T
	) => {
	if ( !eventProps.event.message ) {
		throw new Error(
			`Event ID ${ eventProps.event.id } missing webhook endpoint description`
		);
	}
	return {
		...eventProps,
		icon: 'warning',
		message: (
			<Typography>
				Your webhook { eventProps.event.message } has been paused due to failure.
				Take a look{ ' ' }
				{ toSimpleLink( {
					link: { href: '/admin?tab=integrations' },
					text: 'here',
				} ) }
				.
			</Typography>
		),
		links: [
			{
				type: 'secondary',
				text: 'View',
				link: { href: '/admin?tab=integrations' },
			},
		],
	};
};
